__turbopack_context__.v({
  "container": "klCoFW_container",
  "isSticky": "klCoFW_isSticky",
});
